module.exports = __webpack_public_path__ + "static/media/scan.3d577829.svg";